import { render } from "./Success.vue?vue&type=template&id=c863243a&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=c863243a&scoped=true&lang=css"

import exportComponent from "/Users/ozgurozkankar/Desktop/validationPage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c863243a"]])

export default __exports__